import axios from "axios";
import authHeader from "./auth-header";

import { API_URL } from "./constants";

class OrderTagsService {
  updateOrderTags(id, data) {
    return axios.put(API_URL + `order/tags/update/${id}`, data, {
      headers: authHeader(),
    });
  }

  fetchOrderTags(id) {
    return axios.get(API_URL + `order/tags/fetch/${id}`, {
      headers: authHeader(),
    });
  }

  fetchOrderTagsByStoreId(storeId) {
    return axios.get(API_URL + `order/tags/fetch-by-store-id/${storeId}`, {
      headers: authHeader(),
    });
  }

  fetchOrderTagLogs(orderId) {
    return axios.get(API_URL + `order/tags/fetch-logs/${orderId}`, {
      headers: authHeader(),
    });
  }
}

export default new OrderTagsService();
